import { Play } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const featuredSeries = [{
  id: "track-1",
  title: "Midnight Resonance",
  episodes: "Electronic",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/midnight_resonance_cover.png"
}, {
  id: "track-2",
  title: "Neon Pulse",
  episodes: "Synthwave",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/neon_pulse_cover.png"
}, {
  id: "track-3",
  title: "Void Echoes",
  episodes: "Ambient",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/void_echoes_cover.png"
}, {
  id: "track-4",
  title: "Signal Drift",
  episodes: "Lo-Fi",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/signal_drift_cover.png"
}, {
  id: "track-5",
  title: "Cybernetic Soul",
  episodes: "Techno",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/cybernetic_soul_cover.png"
}, {
  id: "track-6",
  title: "Aetheric Waves",
  episodes: "Cinematic",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/aetheric_waves_cover.png"
}, {
  id: "track-7",
  title: "Digital Horizon",
  episodes: "Progressive",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/digital_horizon_cover.png"
}, {
  id: "track-8",
  title: "Sonic Rebellion",
  episodes: "Industrial",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/sonic_rebellion_cover.png"
}];
export default function TheNeonVault() {
  return <section data-section-id="221571" id="the-sonic-portfolio" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex items-center gap-4 mb-12">
          <div className="w-2 h-10 bg-primary rounded-full shadow-[0_0_15px_rgba(0,255,255,0.5)]"></div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tighter">
            The Sonic Portfolio
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {featuredSeries.map((series, i) => <Link to="/TheSoundPage" key={series.id} data-index={i} className="group block relative overflow-hidden rounded-2xl border border-border/20 bg-card transition-all duration-500 hover:scale-105 hover:border-primary/50 hover:shadow-4xl hover:z-10">
              <AspectRatio ratio={1 / 1}>
                {}
                <img src={series.image} alt={series.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />

                {}
                <div className="absolute inset-0 bg-background/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10">
                  <div className="bg-primary/10 p-4 rounded-full shadow-2xl border border-primary/20 animate-pulse">
                    <Play className="w-10 h-10 text-primary fill-primary ml-1" />
                  </div>
                </div>

                {}
                <div className="absolute bottom-0 left-0 right-0 h-[35%] bg-gradient-to-t from-background/90 via-background/60 to-transparent backdrop-blur-md border-t border-white/5 p-5 flex flex-col justify-end z-20">
                  <h3 className="font-default font-bold text-lg md:text-xl text-foreground line-clamp-1 group-hover:text-primary transition-colors">
                    {series.title}
                  </h3>
                  <div className="flex items-center justify-between mt-1">
                    <p className="font-sans text-sm text-muted-foreground">
                      PulseWave Studios
                    </p>
                    <span className="text-[10px] uppercase tracking-widest font-mono px-2 py-0.5 rounded-full bg-primary/10 text-primary border border-primary/20">
                      {series.episodes}
                    </span>
                  </div>
                </div>
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}